export default __webpack_public_path__ + "static/media/Torn Off Wisdom.b29d5329.png";